import loadConfigFromMeta from '@embroider/config-meta-loader';

const config = globalThis.Ssr?.appConfig
  || loadConfigFromMeta('rise-ui');

globalThis.env = () => console.log(config);

export default config;
